module.exports = __webpack_public_path__ + "img/bianpao_down_code.9e67e2cc.png";